import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "./authProvider";
import { useRoles } from "@/context/rolesContext";
import { RouteUrl } from "@/configs/router/routes";

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRole?: string | string[];
}

export const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { hasRole, isLoading: rolesLoading } = useRoles();
    const navigate = useNavigate();
    const requiredRoles = requiredRole ? (Array.isArray(requiredRole) ? requiredRole : [requiredRole]) : undefined;

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate({ to: RouteUrl.Login });
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading || (requiredRoles && rolesLoading)) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <div>Loading...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return null;
    }

    if (requiredRoles && !hasRole(...requiredRoles)) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <div>You don't have access to this page.</div>
            </div>
        );
    }

    return <>{children}</>;
};
